window.requestAnimFrame = (() => {
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60)
    }
})()

const scrollToY = (scrollTargetY, speed, easing) => {
  var scrollY = window.scrollY || document.documentElement.scrollTop
  var currentTime = 0

  scrollTargetY = scrollTargetY || 0
  speed = speed || 2000
  easing = easing || 'easeOutSine'

  // min time .1, max time .8 seconds
  var time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8))

  // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
  var easingEquations = {
    easeOutSine: (pos) => {
      return Math.sin(pos * (Math.PI / 2))
    },
    easeInOutSine: (pos) => {
      return (-0.5 * (Math.cos(Math.PI * pos) - 1))
    },
    easeInOutQuint: (pos) => {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5)
      }
      return 0.5 * (Math.pow((pos - 2), 5) + 2)
    }
  }

  // add animation loop
  const tick = () => {
    currentTime += 1 / 60

    var p = currentTime / time
    var t = easingEquations[easing](p)
    if (p < 1) {
      window.requestAnimFrame(tick)
      window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t))
    } else {
      window.scrollTo(0, scrollTargetY)
    }
  }

  // call it once to get started
  tick()
}

export {
  scrollToY
}
